export const NEW_TIMESTAMP_PREFIX = 'new-timestamp';
